module.exports = __webpack_public_path__ + "static/media/tomerL.67346450.png";